import React, { useEffect, useState } from 'react';

// Servicios.
import SeguridadService from '../services/seguridadService';

// Components
import Heading from '../components/heading/Heading';
import CustomNoRowsOlverlay from '../components/custom/CustomNoRowsOlverlay';
import Item from '../components/custom/Item';
import msgNotificacion from "../scripts/notification";
import Formatter from '../scripts/formatters';
import { 
  Grid,   
  Stack,
  Tooltip,
  IconButton,
  Button
} from "@mui/material";

//
import PermisoDataGrid from '../components/styledDataGrid/PermisosDataGrid';
import msgAlerta from '../scripts/alert';

// Modals.
import ModalMenu from '../components/modal/Menu';

// Iconos.
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

// Redux.
import { useDispatch } from 'react-redux';
import { showProgress } from '../redux/reducers/progress.Slice';
import { PAGE_SIZE, NAME_PROJECT } from '../redux/constants/index';

export default function Menus() {
  const dispatch = useDispatch()
  const [selectionModel, setSelectionModel] = useState()  
  const [loading, setLoading] = useState(false)
  const [dataMenus, setDataMenus] = useState([])  
  const [editMenu, setEditMenu] = useState(false)  
  const [openModalMenu, setOpenModalMenu] = useState(false)
  const [noChanges, setNoChanges] = useState(true)
  const [dataSelected, setDataSelected] = useState(null)
  const [isMenu, setIsMenu] = useState(false)
  
  const columnsMenus = [
    { 
      field: 'IdMenu', 
      headerName: 'Id Menu',
      headerAlign: 'center',
      align: 'center',
      minWidth: 80, 
    },
    { 
      field: 'Menu', 
      headerName: 'Menú',
      headerAlign: 'center',
      align: 'center',
      minWidth: 120,
      flex: 1
    },
    { 
      field: 'UrlPath', 
      headerName: 'Url de Acceso', 
      headerAlign: 'center',
      align: 'center',      
      minWidth: 120,
      flex: 1
    },
    { 
      field: 'Icono', 
      headerName: 'Icono', 
      headerAlign: 'center',
      align: 'center',      
      minWidth: 100,
      flex: 1
    },
    {
      field: 'Acciones',
      headerName: 'Acciones',
      minWidth: 100,
      headerAlign: 'center',
      renderCell: (params) => {
        const editarMenu = (e) => {
          const data = params.row
          
          setEditMenu(true)
          setOpenModalMenu(true)
          setIsMenu(!data?.IsSubMenu)
          setDataSelected(data)
        }

        const eliminarLinea = () => {
          try {
            msgAlerta('Eliminar menú', '¿Estás seguro que lo desea eliminar este menú?', 'question', eliminarMenu)
          } catch (error) {
            console.error(error)
          }
        }

        const eliminarMenu = () => {
          try {            
            const dataObject = params.row;

            const data = {
              codMenu: dataObject?.IdMenu,
              isMenu: !dataObject?.IsSubMenu
            }
                        
            SeguridadService.eliminarMenu(data)
              .then((response) => {
                if (!response) {
                  msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
                  return
                }
  
                if (response.Codigo === 1) {
                  msgNotificacion(response.Mensaje, 'success')
                  getMenus()
                } else {                  
                  msgAlerta('Error de validación', response.Mensaje, 'warning')
                }
              })
              .catch((error) => {
                console.log('Error:', error.message)
              })
          } catch (error) {
            console.error(error)
          }
        }
        
        return (
          <Stack direction='row' justifyContent='center'>
            <Tooltip title='Editar menú'>
              <IconButton aria-label='buscar' color='info' onClick={editarMenu}>
                <EditIcon fontSize='medium'/>
              </IconButton>
            </Tooltip>
            <Tooltip title='Eliminar menú'>
              <IconButton aria-label='buscar' color='error' onClick={eliminarLinea}>
                <DeleteIcon fontSize='medium' />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      }
    },
  ]

  const getMenus = async () => {
    try {      
      setLoading(true)

      SeguridadService.getMenus()
      .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            setLoading(false)
            return
          }          
  
          setTimeout(() => {
            if (response.Codigo === 1) {
              setDataMenus(response.Data)
            } else {
              setDataMenus([])
              msgNotificacion(response.Mensaje, 'info', 1000)
            }
            setLoading(false)
          }, 500);
      })
      .catch((error) => {
        dispatch(showProgress(false));
        msgNotificacion(error, 'error')
      })
    } catch (error) {
      console.error(error)
    }
  }
  
  const addMenu = () => {
    setEditMenu(false)
    setIsMenu(true)
    setOpenModalMenu(true)
  }

  const addSubMenu = () => {
    setEditMenu(false)
    setIsMenu(false)
    setOpenModalMenu(true)
  }
 
  let didInit = false

  useEffect(() => {    
    document.title = `Listado de Accesos - ${NAME_PROJECT}`
    
    try {
      dispatch(showProgress(true))
      setTimeout(() => {
        
        if (!didInit) {
          getMenus()
        }
  
        dispatch(showProgress(false))
      }, 1000) 
    } catch (error) {
      console.error(error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  
  useEffect(() => {
    try {      
      if (!didInit) {
        if (!openModalMenu) {
          if (!noChanges) {
            setDataMenus([])
            getMenus()
            setNoChanges(true)          
          }
        }
      }
    } catch (error) {
      console.error(error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModalMenu, didInit])


  return (
    <div className='App-content'>
      <Heading className='mt-0 py-0 w-100 heading justify-content-center'>
        <div className='heading-text'>
          <i className='bx bxs-color mx-1'></i>
          <span>Administración de accesos</span>
        </div>       
      </Heading>

      <div className='row w-100 mb-4'>      
        <ModalMenu
          setOpenModal={setOpenModalMenu}
          openModal={openModalMenu}
          setNoChanges={setNoChanges}
          dataMenu={dataSelected}
          isEdit={editMenu}
          isMenu={isMenu}
        />

        <Grid container spacing={1}>
          <Grid item xs={12} md={12} className='pb-2 heading-buttons'>
            <Button
              variant='contained'
              color='info'
              className='text-transform-none float-right me-2'
              startIcon={<AddCircleIcon />}
              size='small'
              onClick={() => addMenu()}
            >
              Agregar menú
            </Button>
            <Button
              variant='contained'
              color='secondary'
              className='text-transform-none float-right me-2'
              startIcon={<AddCircleOutlineIcon />}
              size='small'
              onClick={() => addSubMenu()}
            >
              Agregar sub-menú
            </Button>
          </Grid>

          <Grid item xs={12} md={12}>
            <Item className='MuiPaper-root-dataGrid'>
              <PermisoDataGrid 
                rows={dataMenus}
                getRowId={(row) => row.Consecutivo}
                columns={columnsMenus}
                pageSize={PAGE_SIZE}
                pageSizeOptions={[10, 20, 50, 100]}
                loading={loading}
                localeText={Formatter.localizedTextsMapColumns}                
                showCellVerticalBorder
                showColumnVerticalBorder
                checkboxSelection
                getRowClassName={(params) => `super-app-theme--${params.row?.IsSubMenu}`}
                onRowSelectionModelChange={(selection) => {                  
                  if (selection.length > 1) {
                    const selectionSet = new Set(selectionModel)
                    const result = selection.filter((s) => !selectionSet.has(s))                    

                    setSelectionModel(result)                    
                  } else {
                    setSelectionModel(selection)                    
                  }
                }}
                // Ocultar la casilla de check all.
                sx={{
                  "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
                    display: "none"
                  }
                }}
                rowSelectionModel={selectionModel}
                density='compact'
                slots={{
                  noRowsOverlay: CustomNoRowsOlverlay
                }}
              />
            </Item>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}